export const BASE_CLASS_NAME = 'ui-tooltip';
export const SIZES = ['large', 'medium', 'small'] as const;
export const THEMES = ['dark', 'grey', 'light'] as const;
export const POINTER_POSITIONS = [
  'bottom-right',
  'bottom-left',
  'bottom-center',
  'top-left',
  'top-right',
  'top-center',
  'left',
  'right',
] as const;

export type Size = typeof SIZES[number];
export type Theme = typeof THEMES[number];
export type PointerPositions = typeof POINTER_POSITIONS[number];
export type TargetElement = HTMLDivElement;
